module.exports = __webpack_public_path__ + "img/camp.5fdf46dd.png";